import { isDefined } from '@rainbow-modules/validation';
import { PURPLE_600 } from '../../../../../../../constants';
import { NewContentCell } from './styled';

interface Props {
    row?: Record<string, unknown>;
    fallbackValue?: string;
}

const NewContentColumn = ({ row, fallbackValue = '' }: Props) => {
    const newContent = (row?.content as Record<string, string>)?.new;
    const cellValue = isDefined(newContent) ? newContent : fallbackValue;
    const hasError = newContent === 'Error';
    const color = isDefined(newContent) ? PURPLE_600 : undefined;
    return (
        <NewContentCell hasError={hasError} color={color}>{cellValue}</NewContentCell>
    );
};

export default NewContentColumn;
